import React from "react";
import {
  Grid,
  withStyles,
} from "@material-ui/core";

import InputLabel from "@material-ui/core/InputLabel";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const RecordPreview = (props) => {
  const { data, classes } = props;
  const { record = {} } = data;
  const { t } = useTranslation();

  const dunsNumber =
    record["DUNS number"] === "[No DUNS number found]"
      ? "-"
      : record["DUNS number"];
  const { address = {} } = record;
  const {
    addressLine1,
    addressLine2,
    addressType,
    city,
    countryIso3,
    postalCode,
    stateProvince,
  } = address;

  return (
    <div>
      <Grid container direction="row" spacing={1}>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.fullName")} :</InputLabel>
          <span>{record && record["Full name"]}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.countryOfOperation")} :
            </InputLabel>
          <span>
            {record && record["Country of operations"]
              ? record["Country of operations"]
              : "-"}
          </span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.jllUniqueId")} :
            </InputLabel>
          <span>
            {record && record["JLL unique ID"]
              ? record["JLL unique ID"]
              : "-"}
          </span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.dunsNumber")} :
            </InputLabel>
          <span>{dunsNumber ? dunsNumber : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.addressLine1")} :
            </InputLabel>
          <span>{addressLine1 ? addressLine1 : "-"}</span>
        </Grid>

        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.addressType")} :
            </InputLabel>
          <span>{addressType ? addressType : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.city")} :</InputLabel>
          <span>{city ? city : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>
            {t("labels.record.search.form.stateOrProvince")} :
            </InputLabel>
          <span>{stateProvince ? stateProvince : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.country")} :</InputLabel>
          <span>{countryIso3 ? countryIso3 : "-"}</span>
        </Grid>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.postCode")} :</InputLabel>
          <span>{postalCode ? postalCode : "-"}</span>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RecordPreview);
